module.exports = __webpack_public_path__ + "2023124:cb48231cec1aa2d91890/img/featured_image@2x.94c4140.jpg";